import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState("id");
  const [content, setContent] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api
      .get("/site")
      .then((r) => {
        setContent(r.data.content);
        setProducts(r.data.products || []);
      })
      .catch(() => {});
  }, []);

  const t = (v) => {
    if (v == null) return "";
    if (typeof v === "string") return v;
    return v[lang] ?? v.id ?? "";
  };

  const wa = (msg) =>
    `https://wa.me/${content?.whatsapp || "6281234567890"}?text=${encodeURIComponent(msg)}`;

  return (
    <Ctx.Provider value={{ lang, setLang, content, setContent, products, setProducts, t, wa }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
